import { useState } from "react";
import { Box } from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import FooterInpho from "./FooterInpho";
import FooterCertificates from "./Certificate/FooterCertificates";
import FooterLinks from "./Links/FooterLinks";
import FooterNetworks from "./Networks/FooterNetworks";
import FooterLists from "./List/FooterLists";
import FooterCommunications from "./Communication/FooterCommunications";

export default function FooterManage() {
  const location = useLocation();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [expanded, setExpanded] = useState(
    location.state && location.state.expanded
      ? location.state.expanded
      : "panel9"
  );

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/homepagemanage",
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/homepagemanage" },
          {
            name: "مدیریت فوتر",
            url: "/footerManage",
          },
        ],
      }}
    >
      <Box>
        <FooterInpho />
        <FooterCertificates expanded={expanded} setExpanded={setExpanded} />
        <FooterLinks expanded={expanded} setExpanded={setExpanded} />
        <FooterNetworks expanded={expanded} setExpanded={setExpanded} />
        <FooterLists expanded={expanded} setExpanded={setExpanded} />
        <FooterCommunications expanded={expanded} setExpanded={setExpanded} />
      </Box>
    </Detail>
  );
}
